import React from 'react';
import PropTypes from 'prop-types';
import { PsTable } from '../table/PsTable';
import { I18nUtils } from '../../../../i18n/I18nUtils';

export const PsListTable = (
    {
        data,
        error,
        loading,
        headings,
        children,
    },
) => {
    if ( error ) {
        return (
            <section className={'error-section'}>
                <h3 className={'text-center'}>{error}</h3>
            </section>
        );
    }

    if ( !loading && data.length === 0 ) {
        return (
            <section className={'error-section'}>
                <h3 className={'text-center'}>{I18nUtils.tr('TR_NO_EXISTEN_RESULTADOS')}</h3>
            </section>
        );
    }

    return (
        <PsTable headings={headings}>
            {children}
        </PsTable>
    );
};

PsListTable.propTypes = {
    data: PropTypes.array,
    error: PropTypes.string,
    loading: PropTypes.bool,
    headings: PropTypes.element.isRequired,
};

PsListTable.defaultProps = {
    data: [],
    error: '',
    loading: false,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/list-table/PsListTable.jsx